import React, { useMemo, useState } from "react";
import classNames from "classnames";
import { useStores } from "_common/hooks";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { formatBalance, formatNumber } from "_common/utils/formatValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import {
  faRotate,
  faEye,
  faEyeSlash,
  faAngleDown,
} from "@fortawesome/free-solid-svg-icons";

import line_image from "assets/icons/line_image.svg";
import icon_recharge from "assets/icons/icon_recharge.svg";
import icon_withdraw from "assets/icons/icon_withdraw.svg";
import icon_order from "assets/icons/icon_order.svg";
import icon_bill from "assets/icons/icon_bill.svg";

const General = observer(() => {
  const {
    authStore: { display_balance, setDisplayBalance, user, tokens },
  } = useStores();

  const usdtBalance = useMemo(
    () => user?.tokens?.find((obj) => obj.symbol === "vnd"),
    [user]
  );

  const [active, setActive] = useState("main");

  const listCoin = useMemo(() => {
    if (active === "coin")
      return tokens?.filter((obj) => obj?.symbol === "btc");

    return tokens;
  }, [active, tokens]);

  return (
    <div id="general">
      <div className="flex flex-col w-full gap-10 ">
        <div className="flex flex-1">
          <div className="flex flex-col w-full gap-4">
            <div className="p-4 bg-[#1c1c1e] rounded">
              <span className="text-[14px] text-[#888]">
                {i18next.t("account_balance")}{" "}
              </span>
              <div className="flex items-center gap-3 mt-2 mb-1">
                <span className="text-white text-[32px]">
                  {formatBalance(user?.balance, display_balance)}
                </span>
                <span className="self-end text-white text-base">USDT</span>
                <span
                  className="text-[20px]"
                  onClick={() => setDisplayBalance(!display_balance)}
                >
                  <FontAwesomeIcon
                    icon={display_balance ? faEye : faEyeSlash}
                  />
                </span>
              </div>
              <div className="relative inline-block text-right">
                <Link to="/board/wallet" className="text-[#888] text-base">
                  ≈{formatBalance(user?.balance, display_balance)} USD{" "}
                  <FontAwesomeIcon icon={faAngleDown} />
                </Link>
              </div>
              <div className="text-[15px] text-white pt-2">
                {i18next.t("profit_today")}: &nbsp;
                <span
                  className={classNames({
                    "text-green-500": user?.profit_total_today >= 0,
                    "text-red-500": user?.profit_total_today < 0,
                  })}
                >
                  {formatNumber(user?.profit_total_today, "0,0.[000]")}(
                  {formatNumber(user?.profit_percent_today, "0,0.[00]")}%)
                </span>
                &nbsp; USDT
              </div>
              <img src={line_image} alt="" />
            </div>
            <div className="flex gap-2 text-md text-white">
              <Link
                to="/member/recharge"
                className="bg-[#1c1c1e] flex-1 flex flex-col items-center p-2 rounded"
              >
                <img src={icon_recharge} alt="" width="48" height="48" />
                <span>{i18next.t("recharge")}</span>
              </Link>
              <Link
                to="/member/withdraw"
                className="bg-[#1c1c1e] flex-1 flex flex-col items-center p-2 rounded"
              >
                <img src={icon_withdraw} alt="" width="48" height="48" />
                <span>{i18next.t("withdraw")}</span>
              </Link>
              <Link
                to="/contract/history"
                className="bg-[#1c1c1e] flex-1 flex flex-col items-center p-2 rounded"
              >
                <img src={icon_order} alt="" width="48" height="48" />
                <span>{i18next.t("order")}</span>
              </Link>
              <Link
                to="/board/histories/balance"
                className="bg-[#1c1c1e] flex-1 flex flex-col items-center p-2 rounded"
              >
                <img src={icon_bill} alt="" width="48" height="48" />
                <span>{i18next.t("bill")}</span>
              </Link>
            </div>
            <h3 className="text-[16px] font-bold text-white">
              {i18next.t("my_assets")}
            </h3>
            <div className="flex flex-col gap-2">
              <div className="bg-[#1c1c1e] p-4 rounded">
                <span className="text-sm text-[#888]">
                  {i18next.t("money")}
                </span>
                <div className="text-[15px]">
                  {formatBalance(user?.balance, display_balance)} USDT
                </div>
              </div>
              <div className="bg-[#1c1c1e] p-4 rounded">
                <span className="text-sm text-[#888]">
                  {i18next.t("finance_manager")}
                </span>
                <div className="text-[15px]">
                  {formatBalance(user?.balance_finance, display_balance)} USDT
                </div>
              </div>
              <div className="bg-[#1c1c1e] p-4 rounded">
                <span className="text-sm text-[#888]">
                  {i18next.t("robot_trade")}
                </span>
                <div className="text-[15px]">
                  {formatBalance(user?.balance_robot, display_balance)} USDT
                </div>
              </div>
              <div className="bg-[#1c1c1e] p-4 rounded">
                <span className="text-sm text-[#888]">
                  {i18next.t("refresh_balance")}
                </span>
                <div className="text-[15px]">
                  {formatBalance(user?.balance_reload, display_balance)} USDT
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default General;
